<template>
  <div class="product-list">
    <!-- <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="协议名称">
          <el-input size="small" v-model="searchForm.search" placeholder="请输入协议名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加协议</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="id" label="ID" width="80px">
          </el-table-column>
          <el-table-column prop="title" label="协议名称" width="150px">
          </el-table-column>
          <el-table-column prop="content" label="协议正文" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="sort" label="排序"></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑协议</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small">删除协议</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        search: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/setting/policy/add");
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      SettingApi.privacylist(Params, true)
        .then(data => {
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/setting/policy/edit",
        query: {
          id: row.id,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          SettingApi.privacydelete({
            id: row.id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/policy/index.vue